import React from 'react';
import withReducer from '@Hooks/withReducer';
import { connect } from 'react-redux';
import StructureZoomService from '@Services/StructureZoom';
import { zoomValueByKey } from '../ZoomSelectors';
import zoomReducer from '../ZoomReducer';
import { zoomReducerKey } from '../ZoomConstants';
import ZoomSlider from './ZoomSlider';

function mapStateToProps(state, ownProps) {
  return {
    zoomValue: zoomValueByKey(state, ownProps),
  };
}

const mapDispatchToProps = {};

function ZoomSliderContainer(props) {
  const setZoomValue = (key, value) => {
    StructureZoomService.publish(key, value);
  };

  return <ZoomSlider {...props} setZoomValue={setZoomValue} />;
}

const EnhancedZoomSliderContainer = withReducer(
  zoomReducerKey,
  zoomReducer,
  true
)(connect(mapStateToProps, mapDispatchToProps)(ZoomSliderContainer));

export default EnhancedZoomSliderContainer;
